// extracted by mini-css-extract-plugin
export var copyableField = "_ip-4";
export var customerBadge = "_ip-0";
export var customerInfoTitle = "_ip-2";
export var details = "_ip-1";
export var dropdownContainer = "_ip-5";
export var dropdownImage = "_ip-6";
export var editAssigneeForm = "_ip-a";
export var editButton = "_ip-3";
export var email = "_ip-7";
export var hidden = "_ip-d";
export var input = "_ip-8";
export var saveButton = "_ip-b";
export var shopifyIcon = "_ip-c";
export var suggestionBadge = "_ip-e";
export var suggestionText = "_ip-f";
export var username = "_ip-9";